exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".TargetRangeLines--targetRangeLine--3kXJD{pointer-events:none;stroke:#fff;stroke-dasharray:9,9;stroke-width:2px}", ""]);

// exports
exports.locals = {
	"targetRangeLine": "TargetRangeLines--targetRangeLine--3kXJD"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?importLoaders=1&modules&localIdentName=[name]--[local]--[hash:base64:5]!./~/postcss-loader!./src/components/trends/common/TargetRangeLines.css
 ** module id = 158
 ** module chunks = 0
 **/